const PX_UNIT_NUMBER_REGEXP = /^(\d*(\.\d+))px$/
const REM_UNIT_NUMBER_REGEXP = /^(\d*(\.\d+))rem$/

// These values should be consistent with client/styles/styleguide/responsive

const responsiveWidths = {
  // Materialize breakpoints
  xsmall: 410,
  small: 600,
  medium: 992,
  large: 1200,
  xlarge: 1450,
  xxlarge: 1800,
  xxxlarge: 2400,

  // Work & Co. design breakpoints
  'medium-narrow': 900,
  'medium-wide': 992,

  // Mobile-device specific breakpoints
  'mobile-small': 320, // iPhone 5/SE
  'mobile-medium': 375, // iPhone 6/7/8/X
  'mobile-large': 414 // iPhone 6/7/8 Plus
}

const mediaQueries = {
  'xsmall-and-down': mediaMaxWidth('xsmall'),
  'small-and-down': mediaMaxWidth('small'),
  'medium-narrow-and-down': mediaMaxWidth('medium-narrow'),
  'medium-wide-and-down': mediaMaxWidth('medium-wide'),
  'medium-and-down': mediaMaxWidth('medium'),
  'large-and-down': mediaMaxWidth('large'),
  'xlarge-and-down': mediaMaxWidth('xlarge'),
  'xxlarge-and-down': mediaMaxWidth('xxlarge'),
  'xxxlarge-and-down': mediaMaxWidth('xxxlarge'),

  'mobile-small-and-down': mediaMaxWidth('mobile-small'),
  'mobile-medium-and-down': mediaMaxWidth('mobile-medium'),
  'mobile-large-and-down': mediaMaxWidth('mobile-large'),

  'small-and-up': mediaMinWidth('xsmall'),
  'medium-and-up': mediaMinWidth('small'),
  'medium-narrow-and-up': mediaMinWidth('small'),
  'medium-wide-and-up': mediaMinWidth('medium-narrow'),
  'large-and-up': mediaMinWidth('medium'),
  'xlarge-and-up': mediaMinWidth('large'),
  'xxlarge-and-up': mediaMinWidth('xlarge'),
  'xxxlarge-and-up': mediaMinWidth('xxlarge'),

  'small-only': mediaBetweenWidths('xsmall', 'small'),
  'medium-narrow-only': mediaBetweenWidths('small', 'medium-narrow'),
  'medium-wide-only': mediaBetweenWidths('medium-narrow', 'medium-wide'),
  'medium-only': mediaBetweenWidths('small', 'medium'),
  'large-only': mediaBetweenWidths('medium', 'large'),
  'xlarge-only': mediaBetweenWidths('large', 'xlarge'),
  'xxlarge-only': mediaBetweenWidths('xlarge', 'xxlarge')
}

// These functions should be consistent with client/styles/styleguide/modules/responsive

function parseNumber(number) {
  if (Number.isFinite(number)) {
    return number
  }
  if (PX_UNIT_NUMBER_REGEXP.test(number)) {
    return parseFloat(number)
  }
  if (REM_UNIT_NUMBER_REGEXP.test(number)) {
    return parseFloat(number) * 16
  }
  return NaN
}

function mediaWidth(width) {
  const resolved = responsiveWidths[width]
  if (typeof resolved === 'number') {
    return resolved
  }
  const parsed = parseNumber(width)
  if (Number.isFinite(parsed)) {
    return parsed
  }
  throw new Error(`Unexpected mediaWidth[${width}]`)
}

function mediaMinWidth(minWidth) {
  return `(min-width: ${mediaWidth(minWidth) + 1}px)`
}

function mediaMaxWidth(maxWidth) {
  return `(max-width: ${mediaWidth(maxWidth)}px)`
}

function mediaBetweenWidths(smallerWidth, largerWidth) {
  return `${mediaMinWidth(smallerWidth)} and ${mediaMaxWidth(largerWidth)}`
}

function mediaMinHeight(minHeight) {
  return `(min-height: ${parseNumber(minHeight) + 1}px)`
}

function mediaMaxHeight(maxHeight) {
  return `(max-height: ${parseNumber(maxHeight)}px)`
}

function mediaBetweenHeights(smallerHeight, largerHeight) {
  return `${mediaMinHeight(smallerHeight)} and ${mediaMaxHeight(largerHeight)}`
}

module.exports = {
  // Constants
  responsiveWidths,
  mediaQueries,
  // Functions
  mediaWidth,
  mediaMinWidth,
  mediaMaxWidth,
  mediaBetweenWidths,
  mediaMinHeight,
  mediaMaxHeight,
  mediaBetweenHeights
}
